import Tooltip from "components/Tooltip";
import FallbackImage from "newui/components/FallbackImage/FallbackImage"
import { cn } from "utils/helpers";

interface CompanyLogoDisplayProps {
	className?: string;
	displayStyle?: "normal" | "circle";
	showCircle?: boolean;
	size?: "custom" | "xs" | "sm" | "md" | "lg" | "xl" | "xxl";
	supplierLogoUrl: string | null;
	supplierName: string | null;
}

const SIZE_CLASSES: Record<CompanyLogoDisplayProps["size"], string> = {
	custom: "",
	xs: "h-4 w-4",
	sm: "h-5 w-5",
	md: "h-6 w-6",
	lg: "h-8 w-8",
	xl: "h-10 w-10",
	xxl: "h-12 w-12",
}

export const CompanyLogoDisplay = ({ className, displayStyle = "circle", showCircle = true, size = "sm", supplierLogoUrl, supplierName }: CompanyLogoDisplayProps) => {
	const sizeClass = SIZE_CLASSES[size];
	return <Tooltip className="!bg-white !bg-opacity-100" shouldWrapChildren={true} hasArrow={false} label={<FallbackImage
		src={supplierLogoUrl || ""}
		alt={supplierName ?? "Supplier Logo - Name not provided"}
		className={`h-20 w-20 object-contain`}
	/>}><FallbackImage
			src={supplierLogoUrl || ""}
			alt={supplierName ? `${supplierName} logo` : "Supplier Logo - Name not provided"}
			className={cn("object-contain",
				className,
				sizeClass,
				displayStyle === "circle" && "rounded-full",
				showCircle && "border border-gray-300"
			)}
			fallbackSrc="/img/company-placeholder.svg"
		/>
	</Tooltip>
}